var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['phoenix-keyboard-wrapper', 'tablet', ("keyboard-" + (_vm.keyboardType))],
    attrs: {
      "id": "phoenix-keyboard-wrapper"
    }
  }, [_c('div', {
    class: ['MobileOnscreenKeyboard', {
      outline: _vm.showOutline,
      disabled: _vm.keyboardLocked,
      showSpecialKeys: _vm.showSpecialKeys
    }]
  }, _vm._l(_vm.displayKeys, function (row) {
    return _c('div', {
      key: row.name,
      class: [("row " + (row.name)), _vm.theme]
    }, _vm._l(row.keys, function (key) {
      return _c(_vm.getKwtKey(key), {
        key: key.name,
        tag: "component",
        attrs: {
          "name": key.name,
          "character": key.character,
          "alt": key.alt,
          "shift": key.shift,
          "special": key.special,
          "hold-hand": key.hold,
          "row": row.name,
          "press": _vm.handleKeyDown,
          "release": _vm.handleKeyUp
        }
      });
    }), 1);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }